import { render, staticRenderFns } from "./CoachShow.vue?vue&type=template&id=a4afdc7c&scoped=true&"
import script from "./CoachShow.vue?vue&type=script&lang=js&"
export * from "./CoachShow.vue?vue&type=script&lang=js&"
import style0 from "./CoachShow.vue?vue&type=style&index=0&id=a4afdc7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4afdc7c",
  null
  
)

component.options.__file = "CoachShow.vue"
export default component.exports